<template>
  <div>
    <div class="field has-addons">
      <p class="control">
        <router-link
          tag="span"
          :to="{
            name: 'configurations.account',
          }"
          class="button is-medium"
          >Lista</router-link
        >
        <!-- <button class="button is-medium">
          <span>Crear</span>
        </button> -->
      </p>
      <p class="control">
        <button class="button is-medium is-link">
          <span>Crear</span>
        </button>
      </p>
    </div>
    <h1 class="title">Crear Cuenta Contable</h1>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Código</label>
          <div class="control">
            <input
              v-model="cuenta.codigo"
              class="input"
              type="text"
              placeholder="Código"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              v-model="cuenta.nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
    </div>
    <span class="fontMono has-text-link">{{ grupo }}</span>
    <span class="fontMono has-text-link">{{ sgrupo }}</span>
    <span class="fontMono has-text-link">{{ scuenta }}</span>
    <span class="fontMono has-text-link">{{ sscuenta }}</span>
    <div>
      <div class="field">
        <div class="control">
          <label class="checkbox" :disabled="controlform.disabled">
            <input
              v-model="cuenta.esRegistro"
              type="checkbox"
              :disabled="controlform.disabled"
            />
            Es cuenta de registro
          </label>
        </div>
      </div>
      <div v-show="cuenta.esRegistro">
        <strong
          >Conceptos adicionales que se solicitarán en el momento que se hace el
          registro contable:</strong
        ><br /><br />
        <ul>
          <li>
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.tercero" type="checkbox" />
                  Tercero
                </label>
              </div>
            </div>
          </li>
          <li>
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.ccosto" type="checkbox" />
                  Centro de costos
                </label>
              </div>
            </div>
          </li>
          <li>
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.dctoref" type="checkbox" />
                  Documento Referencia
                </label>
              </div>
            </div>
          </li>
          <li>
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.producto" type="checkbox" />
                  Maneja Producto
                </label>
              </div>
            </div>
          </li>
          <li v-show="cuenta.producto">
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.inventario" type="checkbox" />
                  Es Cuenta de Inventario
                </label>
              </div>
            </div>
          </li>
          <li v-show="cuenta.producto">
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.ingreso" type="checkbox" />
                  Es Cuenta de Ingresos
                </label>
              </div>
            </div>
          </li>
          <li v-show="cuenta.producto">
            <div class="field">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.costoProd" type="checkbox" />
                  Es Cuenta de Costo de Producto
                </label>
              </div>
            </div>
          </li>
          <li>
            <div class="field is-grouped">
              <div class="control">
                <label class="checkbox">
                  <input v-model="cuenta.base" type="checkbox" />
                  Base
                </label>
              </div>
              <div v-show="cuenta.base" class="control">
                <input
                  v-model="cuenta.porcentaje"
                  class="input"
                  type="number"
                  placeholder="Porcentaje"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <br />
      <button class="button is-link is-medium" @click="saveAccount">
        Guardar
      </button>
      <router-link
        tag="button"
        :to="{
          name: 'configurations.account',
        }"
        class="button is-light is-medium"
        >Cancelar</router-link
      >
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      cuentas: [],
      cuenta: {
        codigo: "",
        nombre: "",
        esRegistro: false,
        tercero: false,
        ccosto: false,
        dctoref: false,
        producto: false,
        inventario: false,
        ingreso: false,
        costoProd: false,
        base: false,
        porcentaje: "",
        tipo: "cuenta", // 'grupo', 'subGrupo', 'subCuenta'
      },
      controlform: {
        disabled: true,
      },
    };
  },
  computed: {
    grupo() {
      let codigo = this.cuenta.codigo;
      codigo = codigo.substr(0, 1);
      let nombre;
      for (let cuenta of this.cuentas) {
        if (cuenta.codigo === codigo) {
          nombre = cuenta.nombre;
          break;
        }
      }
      return codigo && nombre ? `${codigo} ${nombre}` : "";
    },
    sgrupo() {
      let codigo = this.cuenta.codigo;
      codigo = codigo.substr(0, 2);
      let nombre;
      for (let cuenta of this.cuentas) {
        if (cuenta.codigo === codigo) {
          nombre = cuenta.nombre;
          break;
        }
      }
      return codigo.length === 2 && nombre ? `-> ${codigo} ${nombre}` : "";
    },
    scuenta() {
      let codigo = this.cuenta.codigo;
      codigo = codigo.substr(0, 4);
      let nombre;
      for (let cuenta of this.cuentas) {
        if (cuenta.codigo === codigo) {
          nombre = cuenta.nombre;
          break;
        }
      }
      return codigo.length === 4 && nombre ? `-> ${codigo} ${nombre}` : "";
    },
    sscuenta() {
      let codigo = this.cuenta.codigo;
      codigo = codigo.substr(0, 6);
      let nombre;
      for (let cuenta of this.cuentas) {
        if (cuenta.codigo === codigo) {
          nombre = cuenta.nombre;
          break;
        }
      }
      return codigo.length === 6 && nombre ? `-> ${codigo} ${nombre}` : "";
    },
    codigolength() {
      let codigo = this.cuenta.codigo;
      codigo = codigo.toString();
      const length = codigo.length;
      return length;
    },
  },
  methods: {
    async saveAccount() {
      try {
        console.log(this.codigolength);
        if (
          this.codigolength === 3 ||
          this.codigolength === 5 ||
          this.codigolength === 7 ||
          this.codigolength > 8
        ) {
          this.$store.dispatch("notify", {
            message: `El código de la cuenta no puede tener ${this.codigolength} dígitos`,
            type: "is-warning",
            position: "top-center",
          });
          return false;
        } else {
          if (this.codigolength === 1) {
            this.cuenta.tipo = "grupo";
            this.cuenta.esRegistro = false;
          } else if (this.codigolength === 2) {
            let codigo = this.cuenta.codigo;
            codigo = codigo.substr(0, 1);
            let nombre;
            for (let cuenta of this.cuentas) {
              if (cuenta.codigo === codigo) {
                nombre = cuenta.nombre;
                break;
              }
            }
            if (nombre) {
              this.cuenta.tipo = "subGrupo";
              this.cuenta.esRegistro = false;
            } else {
              this.$store.dispatch("notify", {
                message: `No puede crear esta cuenta de segundo nivel, primero debe crear la cuenta de primer nivel "${this.cuenta.codigo.substr(
                  0,
                  1
                )}"`,
                type: "is-warning",
                position: "top-center",
              });
              return false;
            }
          } else if (this.codigolength === 4) {
            let codigo = this.cuenta.codigo;
            codigo = codigo.substr(0, 2);
            let nombre;
            for (let cuenta of this.cuentas) {
              if (cuenta.codigo === codigo) {
                nombre = cuenta.nombre;
                break;
              }
            }
            if (nombre) {
              this.cuenta.tipo = "subCuenta";
              this.cuenta.esRegistro = false;
            } else {
              this.$store.dispatch("notify", {
                message: `No puede crear esta cuenta de tercer nivel, primero debe crear la cuenta de segundo nivel "${this.cuenta.codigo.substr(
                  0,
                  2
                )}"`,
                type: "is-warning",
                position: "top-center",
              });
              return false;
            }
          } else if (this.codigolength === 6) {
            let codigo = this.cuenta.codigo;
            codigo = codigo.substr(0, 4);
            let nombre;
            for (let cuenta of this.cuentas) {
              if (cuenta.codigo === codigo) {
                nombre = cuenta.nombre;
                break;
              }
            }
            if (nombre) {
              this.cuenta.tipo = "cuenta";
            } else {
              this.$store.dispatch("notify", {
                message: `No puede crear esta cuenta de cuarto nivel, primero debe crear la cuenta de tercer nivel "${this.cuenta.codigo.substr(
                  0,
                  4
                )}"`,
                type: "is-warning",
                position: "top-center",
              });
              return false;
            }
          } else {
            let codigo = this.cuenta.codigo;
            codigo = codigo.substr(0, 6);
            let nombre;
            for (let cuenta of this.cuentas) {
              if (cuenta.codigo === codigo) {
                nombre = cuenta.nombre;
                break;
              }
            }
            if (nombre) {
              this.cuenta.tipo = "cuenta";
            } else {
              this.$store.dispatch("notify", {
                message: `No puede crear esta cuenta de quinto nivel, primero debe crear la cuenta de cuarto nivel "${this.cuenta.codigo.substr(
                  0,
                  6
                )}"`,
                type: "is-warning",
                position: "top-center",
              });
              return false;
            }
          }
          if (!this.cuenta.nombre) {
            this.$store.dispatch("notify", {
              message: `La cuenta debe tener un nombre`,
              type: "is-warning",
              position: "top-center",
            });
            return false;
          }
          if (this.codigolength === 8 && !this.cuenta.esRegistro) {
            this.$store.dispatch("notify", {
              message: `La cuenta ${this.cuenta.codigo} no puede ser agrupadora, debe ser de registro.`,
              type: "is-warning",
              position: "top-center",
            });
            return false;
          }
          let result;
          if (this.$route.params.id) {
            result = await apiServices.put(`/cuenta`, this.cuenta);
          } else {
            result = await apiServices.post(`/cuenta`, this.cuenta);
          }
          if (result.data) {
            if (result.data.message) {
              this.$store.dispatch("notify", {
                message: result.data.message,
                type: "is-warning",
                position: "top-center",
              });
              this.$router.push({
                name: "configurations.account",
              });
            } else {
              this.$store.dispatch("notify", {
                message: this.$route.params.id
                  ? `La cuenta ${this.cuenta.codigo} fue editada con éxito`
                  : `La cuenta ${this.cuenta.codigo} fue creada con éxito`,
                type: "is-primary",
                position: "top-center",
              });
              this.$router.push({
                name: "configurations.account",
              });
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findAccout() {
      try {
        const result = await apiServices.get(`/cuentas`);
        if (result.data) {
          this.cuentas = result.data;
          const order = (orderArray, key) => {
            orderArray.sort((a, b) => {
              return a[key] < b[key] ? -1 : 1;
            });
            return orderArray;
          };
          order(this.cuentas, "codigo");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findAccountbyId() {
      try {
        const result = await apiServices.get(
          `/cuenta/${this.$route.params.id}`
        );
        if (result.data) {
          this.cuenta = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    codigolength(nv, ov) {
      if (nv > 5) {
        this.controlform.disabled = false;
      } else {
        this.controlform.disabled = true;
        this.cuenta.esRegistro = false;
      }
    },
  },
  created() {
    this.findAccout();
    if (this.$route.params.id) {
      this.findAccountbyId();
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/accounts/Accountcreate.vue